export const formatTimeline = (seconds: number) => {
  const totalSeconds = Number.isFinite(seconds) && seconds > 0 ? Math.floor(seconds) : 0;
  const hh = Math.floor(totalSeconds / 3600);
  const mm = Math.floor((totalSeconds % 3600) / 60);
  const ss = totalSeconds % 60;

  if (hh) {
    return `${hh}:${padTime(mm)}:${padTime(ss)}`;
  }
  return `${mm}:${padTime(ss)}`;
};

export const padTime = (string: number) => {
  return ("0" + string).slice(-2);
};
